module.exports = __webpack_public_path__ + "3b9ec59891d962581ef833673449af7b.svg";